import { ok, runSync } from "@maker/result";

function buildUrl(
	url: string,
	searchParams?: Record<string, string | string[]>,
) {
	return runSync(() => {
		let serializedSearchParams = "";

		if (searchParams && Object.values(searchParams).length >= 1) {
			serializedSearchParams = `?${new URLSearchParams(searchParams)}`;
		}

		const builtUrl = new URL(`${url}${serializedSearchParams}`);

		return ok(`${builtUrl}`);
	});
}

export { buildUrl };
